import { Injectable } from '@angular/core';
import { ApiClient } from '../http/api-client';
import {
  CampaignInterface,
  MarketingArchiveStatusFilter,
  PostCampaignInterface,
  PutCampaignInterface,
} from '../../interfaces/campaigns/campaign.interface';
import { AppSettings } from 'src/app/app.settings';

@Injectable({
  providedIn: 'root',
})
export class MarketingCampaignsService {
  constructor(
    private baseRestAngular: ApiClient,
    private restAngular: ApiClient
  ) {
    this.restAngular = this.getCustomRestAngular();
  }

  getCustomRestAngular() {
    return this.baseRestAngular.withBaseUrl(AppSettings.getMarketingEndpoint());
  }

  create(data: PostCampaignInterface): Promise<CampaignInterface | null> {
    return this.restAngular.one('campaigns').customPOST(data).toPromise();
  }

  getAll(status: MarketingArchiveStatusFilter = 'active'): Promise<CampaignInterface[]> {
    return this.restAngular.all('campaigns').getList({ status }).toPromise();
  }

  runById(id: string): Promise<CampaignInterface> {
    return this.restAngular.one('campaigns', id).customPOST({}).toPromise();
  }

  updateById(id: string, data: PutCampaignInterface): Promise<CampaignInterface> {
    if (!data.channel) {
      throw new Error('Campaign update payload requires channel.');
    }

    const payload: PutCampaignInterface = {
      name: data.name,
      description: data.description,
      channel: data.channel,
      data: data.data,
      groupIds: data.groupIds,
    };

    return this.restAngular.one('campaigns', id).customPUT(payload).toPromise();
  }

  renameById(id: string, name: string): Promise<CampaignInterface> {
    return this.restAngular.one('campaigns', id).customPUT({ name }).toPromise();
  }

  cloneById(id: string): Promise<any> {
    return this.restAngular.one('campaigns').one('clone', id).customPOST({}).toPromise();
  }

  archiveById(id: string): Promise<void> {
    return this.restAngular.one('campaigns', id).remove().toPromise();
  }

  getTargetCount(id: string): Promise<any> {
    return this.restAngular.one('campaigns', id).one('count').get().toPromise();
  }
}
